/* unplugin-vue-components disabled */import script from "./class-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./class-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./class-dialog.vue?vue&type=style&index=0&id=4c022af1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c022af1"]])

export default __exports__